import * as DictionaryConstants from "../../../../../../constants/DictionaryConstants";
import * as RoutePathConstants from "../../../../../../constants/RoutePathConstants";
import { API_BASE_URL } from '../../../../../../common/utils/commonUrl';
import http from '../../../../../../common/utils/http';
import moment from 'moment'
import { mapActions, mapGetters, mapState } from 'vuex'


export default {
  data () {
    return {
      isShow: "",
      getMemberStoredValueRecordingPageList: {},
      memberStoredValueRecordTypeList: []
    };
  },
  methods: {
    dateFormate (time) {
      return time ? moment(time).format('YYYY-MM-DD') : '-'
    },
    getMemberDetails () {
      http
        .get(`${API_BASE_URL}/api/wxoa/pmall/wxoaPmall/getMemberStoredValueRecordingPageList?pageNum=1&pageSize=200`)
        .then(res => {
          this.getMemberStoredValueRecordingPageList = res.data.data.dataList
        });
    },
  },
  mounted () {
    this.isShow = this.$route.query.isShow;
    // http.get(API_BASE_URL + '/api/dict/typeCode/' + 'memberStoredValueRecordType')
    //   .then(res => {
    //     this.memberStoredValueRecordTypeList = res.data.data
    //   })  
  }
};



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/page-mail-service/views/car-wash-service/car-wash-service.js